/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * This file is part of Puter.
 *
 * Puter is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import ar from './ar.js';
import bn from './bn.js';
import br from './br.js';
import da from './da.js';
import de from './de.js';
import emoji from './emoji.js';
import en from './en.js';
import es from './es.js';
import fa from './fa.js';
import fi from './fi.js';
import fr from './fr.js';
import he from './he.js';
import hi from './hi.js';
import hu from './hu.js';
import hy from './hy.js';
import id from './id.js';
import it from './it.js';
import ig from './ig.js';
import ja from './ja.js';
import ko from './ko.js';
import ku from './ku.js';
import my from './my.js';
import nb from './nb.js';
import nl from './nl.js';
import nn from './nn.js';
import pl from './pl.js';
import pt from './pt.js';
import ro from './ro.js';
import ru from './ru.js';
import sl from './sl.js';
import sv from './sv.js';
import ta from './ta.js';
import th from './th.js';
import tr from './tr.js';
import ua from './ua.js';
import ur from './ur.js';
import vi from "./vi.js";
import zh from './zh.js';
import zhtw from './zhtw.js';

export default {
    ar,
    bn,
    br,
    da,
    de,
    emoji,
    en,
    es,
    fa,
    fi,
    fr,
    he,
    hi,
    hu,
    hy,
    id,
    ig,
    it,
    ja,
    ko,
    ku,
    my,
    nb,
    nl,
    nn,
    pl,
    pt,
    ro,
    ru,
    sl,
    sv,
    ta,
    th,
    tr,
    ua,
    ur,
    vi,
    zh,
    zhtw,
};
